import {ref, nextTick} from "vue";

export default function () {
    const value = ref(false);

    function trigger() {
        value.value = true;

        nextTick(() => {
            value.value = false;
        });
    }

    return [value, trigger];
}
